// extracted by mini-css-extract-plugin
export default {"root":"AiGrnHistory_root__rSLH6"};